module.exports = __webpack_public_path__ + "static/media/cat-min.cb785a26.PNG";